export const SIGN_TYPES = {
  SIGN_UP: 'SING_UP',
  SIGN_IN: 'SIGN_IN',
} as const;
export type SIGN_TYPE = typeof SIGN_TYPES[keyof typeof SIGN_TYPES];
